import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Container } from '../components/Container';
export function CTA() {
  return <section id="cta" className="relative overflow-hidden border-t border-white/5 bg-zinc-950" data-id="element-559">
      {/* Warped blue shader — echo of TodayVsPigeon */}
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-560">
        <svg className="absolute inset-0 h-full w-full" preserveAspectRatio="none" viewBox="0 0 1200 800" data-id="element-561">
          <defs data-id="element-562">
            <linearGradient id="cta-blue-shader" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-563">
              <stop offset="0%" stopColor="#0c1e4a" data-id="element-564" />
              <stop offset="30%" stopColor="#1e40af" data-id="element-565" />
              <stop offset="55%" stopColor="#2563eb" data-id="element-566" />
              <stop offset="80%" stopColor="#38bdf8" data-id="element-567" />
              <stop offset="100%" stopColor="#0c4a6e" data-id="element-568" />
            </linearGradient>
            <filter id="cta-warp" x="-20%" y="-20%" width="140%" height="140%" data-id="element-569">
              <feTurbulence type="fractalNoise" baseFrequency="0.008 0.011" numOctaves="2" seed="7" result="noise" data-id="element-570">
                <animate attributeName="baseFrequency" dur="30s" values="0.008 0.011; 0.012 0.007; 0.008 0.011" repeatCount="indefinite" data-id="element-571" />
              </feTurbulence>
              <feDisplacementMap in="SourceGraphic" in2="noise" scale="160" data-id="element-572" />
            </filter>
          </defs>
          <g filter="url(#cta-warp)" data-id="element-573">
            <rect x="-200" y="-200" width="1600" height="1200" fill="url(#cta-blue-shader)" data-id="element-574" />
          </g>
        </svg>
        {/* Dark scrim */}
        <div className="absolute inset-0 bg-zinc-950/60" data-id="element-575" />
        {/* Top sheen */}
        <div className="absolute inset-x-0 top-0 h-1/3 bg-gradient-to-b from-white/[0.06] to-transparent" data-id="element-576" />
        {/* Vignette */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,rgba(9,9,11,0.7)_100%)]" data-id="element-577" />
        {/* Grain */}
        <div className="absolute inset-0 opacity-[0.06] mix-blend-overlay" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' /%3E%3C/svg%3E\")"
      }} data-id="element-578" />
      </div>

      <Container className="relative py-24 sm:py-44" data-id="element-579">
        <div className="mx-auto max-w-4xl text-center" data-id="element-580">
          <div className="eyebrow text-accent" data-id="element-581">Get started</div>
          <h2 className="display-tighten text-balance mt-6 font-serif-display text-[2.85rem] leading-[1.0] text-white sm:mt-7 sm:text-8xl sm:leading-[0.95] lg:text-[7.25rem]" data-id="element-582">
            Stop chasing.
            <br data-id="element-583" />
            <span className="italic text-accent" data-id="element-584">Start closing.</span>
          </h2>
          <p className="measure mx-auto mt-6 px-2 text-center text-[15px] leading-relaxed text-zinc-300 sm:mt-8 sm:px-0 sm:text-lg" data-id="element-585">
            See how Pigeon shortens your bind cycle, lifts producer experience,
            and lets your team take on more programs. Live in under 30 days.
          </p>
          <div className="mt-9 flex justify-center sm:mt-12" data-id="element-586">
            <a href="https://calendly.com/pigeondocuments" target="_blank" rel="noopener noreferrer" className="btn-accent btn-accent-lg group" data-id="element-587">
              Book a Call
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-588" />
            </a>
          </div>
        </div>
      </Container>
    </section>;
}